import React from 'react';
import { Table, Badge, Button, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faMobile } from '@fortawesome/free-solid-svg-icons';
import {
  SessionsCard,
  SessionsHeader,
  SessionsTitleRow,
  SectionIconWrap,
  SectionTitle,
  TableWrapper,
  EmptySessionsWrap,
  EmptySessionsIcon,
  EmptySessionsText,
  MerchantBlock,
  MerchantBadgeRow,
  MerchantSessionCount,
} from './Styles';
import {
  SESSIONS_TITLE,
  SESSIONS_EMPTY,
  SESSIONS_TABLE_DEVICE_NAME,
  SESSIONS_TABLE_DEVICE_BRAND,
  SESSIONS_TABLE_DEVICE_TYPE,
} from './constants';
import type { SessionRow, SessionsDetailProps } from './types';

const SessionsDetail: React.FC<SessionsDetailProps> = ({
  merchantsWithSessions,
  onClose,
}) => {
  const hasSessions = merchantsWithSessions.length > 0;

  const columns: ColumnsType<SessionRow> = [
    {
      title: SESSIONS_TABLE_DEVICE_NAME,
      dataIndex: 'deviceName',
      key: 'deviceName',
      render: (val: string) => val ?? '—',
    },
    {
      title: SESSIONS_TABLE_DEVICE_BRAND,
      dataIndex: 'deviceBrand',
      key: 'deviceBrand',
      render: (val: string) => (val ? <Badge color="green">{val}</Badge> : '—'),
    },
    {
      title: SESSIONS_TABLE_DEVICE_TYPE,
      dataIndex: 'deviceType',
      key: 'deviceType',
      render: (val: string) => val ?? '—',
    },
  ];

  return (
    <SessionsCard>
      <div>
        <SessionsHeader>
          <SessionsTitleRow>
            <SectionIconWrap $color="#3b82f6">
              <FontAwesomeIcon icon={faUsers} />
            </SectionIconWrap>
            <SectionTitle>{SESSIONS_TITLE}</SectionTitle>
          </SessionsTitleRow>
          <Button type="text" size="small" onClick={onClose} aria-label="Close">
            ×
          </Button>
        </SessionsHeader>
        {hasSessions ? (
          merchantsWithSessions.map((merchant, index) => (
            <MerchantBlock key={`${merchant.merchantName}-${index}`}>
              <MerchantBadgeRow>
                <Tag color="blue">{merchant.merchantName}</Tag>
                <MerchantSessionCount>
                  {merchant.sessions.length} active session
                  {merchant.sessions.length !== 1 ? 's' : ''}
                </MerchantSessionCount>
              </MerchantBadgeRow>
              <TableWrapper>
                <Table<SessionRow>
                  size="small"
                  columns={columns}
                  dataSource={merchant.sessions.map((s, i) => ({
                    key: `${index}-${i}`,
                    deviceName: s.deviceName,
                    deviceBrand: s.deviceBrand,
                    deviceType: s.deviceType,
                  }))}
                  pagination={false}
                />
              </TableWrapper>
            </MerchantBlock>
          ))
        ) : (
          <EmptySessionsWrap>
            <EmptySessionsIcon>
              <FontAwesomeIcon icon={faMobile} />
            </EmptySessionsIcon>
            <EmptySessionsText>{SESSIONS_EMPTY}</EmptySessionsText>
          </EmptySessionsWrap>
        )}
      </div>
    </SessionsCard>
  );
};

export default React.memo(SessionsDetail);
